import state from './user_state'

const mutations = {
    SET_USERS(state, payload) {
        state.users = payload
    },
    SET_USERS_SUMMARY(state, payload) {
        state.users_summary = payload
    }
}

export default mutations
